import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function Search({ name, edit, submit, search }: Props) {
  const { t } = useTranslation();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      name && search(name);
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [name]);

  return (
    <input
      type="text"
      value={name}
      placeholder={t("search.placeholder")}
      className={styles.search}
      onChange={({ target }) => edit(target.value)}
      onKeyUp={({ key }) => key === "Enter" && submit(name)}
    />
  );
}

export { Search };
